@if (this.contactDetail$ | async; as contactDetail) {
  <div
    class="tab-pane fade flex-even active show"
    id="sales"
    role="tabpanel"
    aria-labelledby="sales-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-6 col-md">
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
              >CONTACT_LBL_SALESTEAM</label
              >
              <div class="col">
                <span class="form-control-plaintext form-control-sm">
                  {{ contactDetail.salesTeamName }}
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
                >CONTACT_LBL_SALESPERSON</label
                >
                <div class="col">
                  <span class="form-control-plaintext form-control-sm">
                    {{ contactDetail.salesPersonName }}
                  </span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-form-label-sm" translate
                  >CONTACT_LBL_MARKETING_CREATION_DATE</label
                  >
                  <div class="col-auto">
                    <span class="form-control-plaintext form-control-sm">
                      {{ contactDetail.creationTime | date : "dd/MM/yyyy" }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md">
                <div class="form-group row">
                  <label class="col-4 col-form-label-sm" translate
                    >CONTACT_LBL_MARKETING_CAMPAIGN</label
                    >
                    <div class="col">
                      <span class="form-control-plaintext form-control-sm">
                        {{ contactDetail.campaignName }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label class="col-4 col-form-label-sm" translate
                      >CONTACT_LBL_MARKETING_MEDIUM</label
                      >
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{ contactDetail.mediumName }}
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate
                        >CONTACT_LBL_MARKETING_SOURCE</label
                        >
                        <div class="col">
                          <span class="form-control-plaintext form-control-sm">
                            {{ contactDetail.sourceName }}
                          </span>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label class="col-4 col-form-label-sm" translate
                          >CONTACT_LBL_MARKETING_REFERRER</label
                          >
                          <div class="col">
                            <span class="form-control-plaintext form-control-sm">
                              @if (!contactDetail.referrerId) {
                                {{ contactDetail.referrerName}}
                              } @else {
                                <app-link-to
                                  [id]="contactDetail.referrerId.toString()"
                                  [label]="contactDetail.referrerName"
                                  [url]="'/Contacts/Contacts/Details/'"
                                  />
                                }
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
